import { render, staticRenderFns } from "./CopyTable.vue?vue&type=template&id=6c990958&scoped=true"
import script from "./CopyTable.vue?vue&type=script&lang=js"
export * from "./CopyTable.vue?vue&type=script&lang=js"
import style0 from "./CopyTable.vue?vue&type=style&index=0&id=6c990958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c990958",
  null
  
)

export default component.exports